"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IMMI_PAGE_SCROLL = exports.IMMI_COMPONENT_IMPRESSION = exports.IMMI_COMPONENT_ACTION = exports.IMMI_PAGE_VIEW = void 0;
exports.IMMI_PAGE_VIEW = "immiPageView";
exports.IMMI_COMPONENT_ACTION = "immiComponentAction";
exports.IMMI_COMPONENT_IMPRESSION = "immiComponentImpression";
exports.IMMI_PAGE_SCROLL = "immiPageScroll";